<template>
  <div class="leadTophead">
    <div class="headImgbox">
      <img src="../../src/assets/images/indipendentday-contest-logo.png" />
    </div>
    <div class="winTitle">{{ $t('WINrupees') }}</div>
  </div>
</template>

<script>
export default {
  name: 'LeaderBoardBanner',
  props: ['type', 'src', 'room_id', 'id']
}
</script>
